import React, { Component } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
// import Constants from "../App/Variables/Constants";
import {
  Backdrop,
  Button,
  Container,
  Fade,
  Grid,
  Box,
  //   GridItem,
  Modal,
  TextField,
  Typography,
  Snackbar,
  Switch,
  FormControlLabel,
  //   InputLabel,
  //   Select,
  //   MenuItem,
} from "@material-ui/core";
import init from "../helpers/WindowToken";
import Constants from "../App/Variables/Constants";
import EditIcon from "@material-ui/icons/Edit";
import { Link } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { makeStyles } from "@material-ui/core";
import { Category } from "@material-ui/icons";

const classes = makeStyles();

export default class AddProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allCategory: [],
      allSubCategory: [],
      category: "",
      sub_category: "",
      name: "",
      description: "",
      reviews: "",
      price: 0,
      quantity: 1,
      meta_key: "",
      meta_title: "",
      best_selling: "",
      insta_reel: "",
      images: [],
      notification: false,
      redirect: false,
      message: "",
      offer_price: 0,
      delivery_charge: 150,
      cod_enabled: true,
    };
    this.handleDescription = this.handleDescription.bind(this);
  }

  componentDidMount() {
    this.getAllCategories();
  }

  getAllCategories = () => {
    axios
      .get(Constants.getUrls.getAllCategory + `?limit=150`)
      .then((resp) => {
        this.setState({
          allCategory: resp.data.data.docs,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getAllSubCategories = () => {
    axios
      .get(
        Constants.getUrls.getAllSubcategory +
          `?limit=150` +
          "&cateId=" +
          this.state.category
      )
      .then((resp) => {
        this.setState({
          allSubCategory: resp.data.data.docs,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleDescription(description) {
    this.setState({
      description,
    });
  }

  handleReviews = (reviews) => {
    this.setState({
      reviews,
    });
  };
  // handleInput = (e) => {
  //   this.setState(
  //     {
  //       [e.target.name]: e.target.value,
  //     },
  //     () => {
  //       if (e.target.name === "category") {
  //         this.getAllSubCategories();
  //       }
        
  //     }
  //   );
  // };

  handleInput = (e) => {
    const { name, value } = e.target;

    let finalValue = value;
    console.log(value);
    
    // Convert Yes/No string to boolean
    if (value === "true") finalValue = true;
    else if (value === "false") finalValue = false;

    this.setState(
      {
        [name]: finalValue,
      },
      () => {
        if (name === "category") {
          this.getAllSubCategories();
        }
      }
    );
  };

  handleToggle = (e) => {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  handleFile = (e) => {
    console.log(e.target.files);
    this.setState({
      [e.target.name]: e.target.files,
    });
  };

  handleSubmit = (e) => {
    this.setState({ loading: true });
    e.preventDefault();

    const fd = new FormData();

    fd.append("description", this.state.description);
    fd.append("reviews", this.state.reviews);
    fd.append("category", this.state.category);
    // fd.append("sub_category", this.state.sub_category);
    fd.append("name", this.state.name);
    fd.append("price", this.state.price);
    fd.append("quantity", this.state.quantity);
    fd.append("meta_key", this.state.meta_key);
    fd.append("meta_title", this.state.meta_title);
    fd.append("best_selling", this.state.best_selling);
    fd.append("insta_reel", this.state.insta_reel);
    fd.append("offer_price", this.state.offer_price);
    fd.append("delivery_charge", this.state.delivery_charge);
    fd.append("cod_enabled", this.state.cod_enabled);
    if (this.state.images.length > 0) {
      for (let i = 0; i <= this.state.images.length - 1; i++) {
        fd.append("images", this.state.images[i]);
      }
    }
    axios
      .post(Constants.postUrls.addProducts, fd)
      .then((resp) => {
        console.log(resp);
        
        if (resp.data.status === "success") {
          this.setState({
            message: resp.data.message,
            notification: true,
          });
          setTimeout(() => {
            this.setState({
              redirect: true,
              notification: false,
              loading: false,
            });
          }, 2000);
        }
      })
      .catch((err) => {
        this.setState({
          notification: true,
          message: err.response.data.message,
        });
        setTimeout(() => {
          this.setState({
            notification: false,
            loading: false,
          });
        }, 2000);
      });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to="/products" />;
    } else {
      return (
        <Container maxWidth="xl">
          <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
            <Grid item xs={6}>
              <Typography variant="h5"> Create Product </Typography>
            </Grid>
          </Grid>

          {/* After Getting api add Snackbar notification here  */}
          {this.state.notification ? (
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={true}
              color={"s"}
              autoHideDuration={6000}
              message={this.state.message}
            ></Snackbar>
          ) : null}

          <div
            style={{
              background: "#5b5757",
              padding: "20px",
              borderRadius: "10px",
              width: "100%",
              border: "0",
              display: "flex",
              position: "relative",
              fontSize: ".875rem",
              minWidth: "0",
              wordWrap: " break-word",
              boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
              marginTop: "30px",
              borderRadius: "6px",
              marginBottom: "30px",
              flexDirection: "column",
              textAlign: "left",
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
                boxShadow:
                  " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
                float: "left",
                padding: "15px",
                marginTop: "-43px",
                marginRight: "15px",
                borderRadius: "3px",
                backgroundColor: "#999",
                width: "6%",
                height: "60px",
                marginBottom: "25px",
                textAlign: "center",
              }}
            >
              <EditIcon />
            </div>

            <form onSubmit={this.handleSubmit}>
              <Grid container sm={12} spacing={2}>
                <Grid item sm={4}>
                  <FormControl
                    // style={{ marginTop: "12px" }}
                    fullWidth
                    className={classes.selectFormControl}
                  >
                    <InputLabel
                      style={{
                        marginLeft: "15px",
                      }}
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      Select Category
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      value={this.state.category}
                      inputProps={{
                        name: "category",
                        id: "simple-select",
                        onChange: this.handleInput,
                        required: true,
                      }}
                    >
                      {this.state.allCategory.map((category, i) => (
                        <MenuItem key={i} value={category._id}>
                          {category.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* <Grid item sm={4}>
                  <FormControl
                    // style={{ marginTop: "12px" }}
                    fullWidth
                    className={classes.selectFormControl}
                  >
                    <InputLabel
                      style={{
                        marginLeft: "15px",
                      }}
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      Select Category
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      value={this.state.sub_category}
                      inputProps={{
                        name: "sub_category",
                        id: "simple-select",
                        onChange: this.handleInput,
                        required: true,
                      }}
                    >
                      {this.state.allSubCategory.map((item, i) => (
                        <MenuItem key={i} value={item._id}>
                          {item.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid> */}

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Name"
                    name="name"
                    value={this.state.name}
                    variant="outlined"
                    required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Price"
                    name="price"
                    value={this.state.price}
                    variant="outlined"
                    required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Delivery Charge"
                    name="delivery_charge"
                    value={this.state.delivery_charge}
                    variant="outlined"
                    required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Offer Price"
                    name="offer_price"
                    value={this.state.offer_price}
                    variant="outlined"
                    required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>
                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Quantity"
                    name="quantity"
                    value={this.state.quantity}
                    variant="outlined"
                    required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Meta Key"
                    name="meta_key"
                    value={this.state.meta_key}
                    variant="outlined"
                    // required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Meta Title"
                    name="meta_title"
                    value={this.state.meta_title}
                    variant="outlined"
                    // required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>

                {/* <Grid item sm={4}>
                  <TextField
                    select
                    label="Best Selling Product"
                    name="best_selling"
                    value={this.state.best_selling}
                    onChange={this.handleInput}
                    variant="outlined"
                    required
                    style={{ marginRight: "3px", width: "100%" }}
                    SelectProps={{ native: true }}
                  >
                    <option value="">Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </TextField>
                </Grid> */}

                <Grid item sm={4}>
                  <label> Select Images (Maximum 4) </label>
                  <input
                    type="file"
                    name="images"
                    multiple
                    onChange={this.handleFile}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Instagram Reel"
                    name="insta_reel"
                    value={this.state.insta_reel}
                    variant="outlined"
                    // required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>
                <Grid item sm={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.cod_enabled}
                        onChange={this.handleToggle}
                        name="cod_enabled"
                        color="primary"
                      />
                    }
                    label="Cash On Delivery"
                  />
                </Grid>
                <Grid item sm={12}>
                  <Typography variant="subtitle1" style={{ color: "#fff", marginBottom: "8px" }}>
                    Product Description
                  </Typography>
                  <SunEditor
                    // width="120%"
                    setOptions={{
                      buttonList: [
                        ["undo", "redo"],
                        ["font", "fontSize"],
                        ["paragraphStyle", "blockquote"],
                        [
                          "bold",
                          "underline",
                          "italic",
                          "strike",
                          "subscript",
                          "superscript",
                        ],
                        ["fontColor", "hiliteColor"],
                        ["align", "list", "lineHeight"],
                        ["outdent", "indent"],

                        ["table", "horizontalRule", "link", "image", "video"],
                        // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                        // ['imageGallery'], // You must add the "imageGalleryUrl".
                        ["fullScreen", "showBlocks", "codeView"],
                        ["preview", "print"],
                        ["removeFormat"],

                        ["save", "template"],
                        // '/', Line break
                      ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                      defaultTag: "div",
                      minHeight: "250px",
                      showPathLabel: false,
                      // font: sortedFontOptions
                    }}
                    name="description"
                    value={this.state.description}
                    onChange={this.handleDescription}
                  />
                </Grid>
                <Grid item sm={12}>
                  <Typography variant="subtitle1" style={{ color: "#fff", marginBottom: "8px" }}>
                    Product Reviews
                  </Typography>
                  <SunEditor
                    setOptions={{
                      buttonList: [
                        ["undo", "redo"],
                        ["font", "fontSize"],
                        ["paragraphStyle", "blockquote"],
                        ["bold", "underline", "italic", "strike"],
                        ["fontColor", "hiliteColor"],
                        ["align", "list", "lineHeight"],
                        ["outdent", "indent"],
                        ["table", "horizontalRule", "link"],
                        ["fullScreen", "showBlocks", "codeView"],
                        ["preview", "print"],
                        ["removeFormat"],
                      ],
                      defaultTag: "div",
                      minHeight: "220px",
                      showPathLabel: false,
                    }}
                    name="reviews"
                    value={this.state.reviews}
                    onChange={this.handleReviews}
                  />
                </Grid>
              </Grid>

              <br />
              <div>
                <Button
                  variant="contained"
                  type="submit"
                  size="small"
                  color="primary"
                  style={{
                    marginRight: "20px",
                    marginTop: "35px",
                  }}
                >
                  {this.state.loading ? "Adding..." : "Add"}
                </Button>
                <Link
                  to={{
                    pathname: "/products",
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    size="small"
                    color="secondary"
                    style={{ marginRight: "20px", marginTop: "35px" }}
                  >
                    Cancel
                  </Button>
                </Link>
              </div>
            </form>
          </div>
        </Container>
      );
    }
  }
}
